import React from "react";
import get from "lodash/get";
import useTranslation from "hooks/useTranslation";
import TableTotalRow from "pages/Main/Storage/components/TableTotalRow";
import TableSimpleRow from "pages/Main/Storage/components/TableSimpleRow";

const TableRestaurantInventoryMetrics = ({ data, title, currency, type, onStorageClick = () => {} }) => {
  const { tr } = useTranslation();

  return (
    <>
      <div className="main-title mb-10">{tr(title)}</div>
      <table className={`default-table default-table-hover ${type === "consumption" || type === "coming" ? "mb-30" : ""}`}>
        <thead>
          <tr>
            <th className="text-cen !px-0">№</th>
            <th>{tr("Название")}</th>
            <th className="text-right">{tr("Сырьё")}</th>
            <th className="text-right">{tr("Полуфабрикат")}</th>
            <th className="text-right">{tr("Реализация")}</th>
            <th className="text-right">{tr("Сумма")}</th>
          </tr>
        </thead>

        <tbody>
          <TableTotalRow data={data} currency={currency} />
          {get(data, "storages", []).map((storage, i) => (
            <TableSimpleRow key={i} storage={storage} index={i} currency={currency} onStorageClick={() => onStorageClick(storage)} />
          ))}
        </tbody>
      </table>
    </>
  );
};

export default TableRestaurantInventoryMetrics;
